// Tracks in-flight API requests so the global loader knows when data is ready.
let pending = 0;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(pending));

export const requestStarted = () => {
  pending += 1;
  notify();
};

export const requestFinished = () => {
  pending = Math.max(0, pending - 1);
  notify();
};

export const getPending = () => pending;

export const subscribePending = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
